export interface Iapplication{
  ID: number;
  Name: string ;
  Description: string;
  Path: string;
  Icono:string;
  Status: boolean;
  UserCreation: string;
  DateCreation: string;
  UserLastUpdate: string;
  DateLastUpdate: string;

}

export class Aplicacion implements Iapplication{
      constructor(
      public ID: number,
      public Name: string ,
      public Description: string,
      public Path: string,
      public Icono:string,
      public Status: boolean,
      public UserCreation: string,
      public DateCreation: string,
      public UserLastUpdate: string,
      public DateLastUpdate: string
   
  ){
      this.ID = ID;
      this.Name=Name;
      this.Description=Description;
      this.Path = Path;
      this.Icono=Icono;
      this.Status=Status;
      this.UserCreation=UserCreation;
      this.DateCreation=DateCreation;
      this.UserLastUpdate=UserLastUpdate;
      this.DateLastUpdate=DateLastUpdate;

  }
}
